import {
  LINKTREES_FETCH,
  LINKTREES_ORDERBY,
  LINKTREES_FILTER,
  LINKTREES_PAGINATION,
  LINKTREE_FETCH,
  LINKTREE_INSERT,
  LINKTREE_UPDATE,
  NETWORK_START,
  NETWORK_ERROR,
  NETWORK_STOP,
} from "../constants";

import {
  fetch_linktrees,
  fetch_linktree,
  insert_linktree,
  update_linktree,
  sort_linktree_links,
  delete_linktree_link,
  update_linktree_link,
} from "../../utils/requestHelper";

/* =========================
 * State Setter
 * ========================= */

export function setLinktreesOrderBy(value) {
  return (dispatch) => {
    dispatch({ type: LINKTREES_ORDERBY, value });
  };
}

export function setLinktreesFilter(value) {
  return (dispatch) => {
    dispatch({ type: LINKTREES_FILTER, value });
  };
}

export function setLinktreesPagination(value) {
  return (dispatch) => {
    dispatch({ type: LINKTREES_PAGINATION, value });
  };
}

/* =========================
 * Fetch List
 * ========================= */

export function fetchLinktrees(filter, limit, skip, orderBy) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });

      const result = await fetch_linktrees(filter, limit, skip, orderBy);

      if (result.success === true) {
        dispatch({
          type: LINKTREES_FETCH,
          result: result.data,
          count: result.count,
        });
      }

      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}

/* =========================
 * Fetch Single
 * ========================= */

export function fetchLinktree(linktreeId) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });

      const result = await fetch_linktree(linktreeId);

      if (result.success === true) {
        dispatch({
          type: LINKTREE_FETCH,
          result: result.data,
        });
      }

      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}

/* =========================
 * Insert
 * ========================= */

export function insertLinktree(data) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });

      const result = await insert_linktree(data);

      if (result.success === true) {
        dispatch({
          type: LINKTREE_INSERT,
          result: result.data,
        });
      }

      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}

/* =========================
 * Update
 * ========================= */

export function updateLinktree(linktreeId, data) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });

      const result = await update_linktree(linktreeId, data);

      if (result.success === true) {
        dispatch({
          type: LINKTREE_UPDATE,
          result: result.data,
        });
      }

      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}

export function deleteLinktreeLink(linkTreeId, linkTreeLinkId) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });

      const result = await delete_linktree_link(linkTreeId, linkTreeLinkId);

      if (!result.success) {
        throw result.error;
      }

      const fetchResult = await fetch_linktree(linkTreeId);

      if (fetchResult.success === true) {
        dispatch({
          type: LINKTREE_FETCH,
          result: fetchResult.data,
        });
      }

      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}

export function updateLinktreeLink(linkTreeId, linkTreeLinkId, data) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });

      const result = await update_linktree_link(
        linkTreeId,
        linkTreeLinkId,
        data,
      );

      if (!result.success) {
        throw result.error;
      }

      const fetchResult = await fetch_linktree(linkTreeId);

      if (fetchResult.success === true) {
        dispatch({
          type: LINKTREE_FETCH,
          result: fetchResult.data,
        });
      }

      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}

export function sortLinktreeLinks(linkTreeId, links) {
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });

      const positions = links.map((link, index) => ({
        id: link.id,
        position: index,
      }));

      const result = await sort_linktree_links(linkTreeId, positions);

      if (!result.success) {
        throw result.error;
      }

      const fetchResult = await fetch_linktree(linkTreeId);

      if (fetchResult.success === true) {
        dispatch({
          type: LINKTREE_FETCH,
          result: fetchResult.data,
        });
      }

      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}
